import {
  SquaresFour,
  Article,
  Tag,
  Hash,
  MagicWand,
  FileText,
  GlobeHemisphereWest,
  MapPin,
  Users,
  Shield,
  Key,
  ChartLine,
  ChartBar,
  Gear,
  ClipboardText,
  Sliders,
  Robot,
} from "@phosphor-icons/react";

export const PORTAL_BASE = "/admin-portal";

/**
 * Navigation tree for the Admin Portal sidebar.
 * Each entry is either a top-level item (no `group`) or a grouped section.
 * `comingSoon: true` renders a "Soon" badge and marks the route as a stub.
 */
export const NAV = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: SquaresFour,
    path: "dashboard",
  },
  {
    group: "Content Management",
    items: [
      { id: "content-articles",   label: "Articles",    icon: Article,   path: "content/articles",   comingSoon: true },
      { id: "content-categories", label: "Categories",  icon: Tag,       path: "content/categories", comingSoon: true },
      { id: "content-tags",       label: "Tags",        icon: Hash,      path: "content/tags",        comingSoon: true },
    ],
  },
  {
    group: "SEO Studio",
    items: [
      { id: "seo-pages",   label: "Generated Pages", icon: MagicWand, path: "seo/pages",   comingSoon: true },
      { id: "seo-csv",     label: "CSV Uploads",     icon: FileText,  path: "seo/csv",     comingSoon: true },
      { id: "seo-sitemap", label: "Sitemap",         icon: Sliders,   path: "seo/sitemap", comingSoon: true },
    ],
  },
  {
    group: "Geo Insights",
    items: [
      { id: "geo-overview",  label: "Visitor Analytics", icon: GlobeHemisphereWest, path: "geo/overview",  comingSoon: true },
      { id: "geo-countries", label: "Countries",         icon: MapPin,              path: "geo/countries", comingSoon: true },
    ],
  },
  {
    group: "Users & Roles",
    items: [
      { id: "users",             label: "All Users",   icon: Users,  path: "users" },
      { id: "users-admins",      label: "Admins",      icon: Shield, path: "users/admins",      comingSoon: true },
      { id: "users-permissions", label: "Permissions", icon: Key,    path: "users/permissions", comingSoon: true },
    ],
  },
  {
    group: "Analytics",
    items: [
      { id: "analytics-traffic", label: "Traffic Overview", icon: ChartLine, path: "analytics/traffic", comingSoon: true },
      { id: "analytics-pages",   label: "Top Pages",        icon: ChartBar,  path: "analytics/pages",   comingSoon: true },
    ],
  },
  {
    group: "AI Platform",
    items: [
      { id: "ai-jobs", label: "Data Fetcher Jobs", icon: Robot, path: "ai-jobs" },
    ],
  },
  {
    group: "System",
    items: [
      { id: "system-settings", label: "Settings",      icon: Gear,          path: "system/settings", comingSoon: true },
      { id: "system-audit",    label: "Audit Logs",    icon: ClipboardText, path: "system/audit",    comingSoon: true },
      { id: "system-config",   label: "Configuration", icon: Sliders,       path: "system/config",   comingSoon: true },
    ],
  },
];
